import { FC } from "react";

import PurchasePolicy from "containers/PurchasePolicy/PurchasePolicy";

const PurchasePolicyRoute: FC = () => {
  return <PurchasePolicy />;
};

export default PurchasePolicyRoute;
